<!-- Show the "2 days still available" flap: -->
<div class="flap-expire" *ngIf="show"
>
    <div class="flap-expire-text-full" >
        {{ 'premium_content_info_flap' | translate }}
    </div>
</div>
